import {Input, Button, Select, Option, Checkbox, Popover, Dialog} from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import {Switch as LSwitch, Checkbox as Checkbox2} from '@/components/index';
import {EventBus} from '@/services/Event.js';
import store from '@/services/store';
import MedalDecider from '@/components/shared/medals/club/decider/decider.vue';
import MembershipPurchaseCard
    from '@/components/user/dashboard/pages/membership/membership-purchase-card/membership-purchase-card.vue';

const svc = new ResourceSvc();

export default {
    name: 'dashboardUpgradeMembership',
    props: ['userId'],
    components: {
        [Input.name]: Input,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
        [Checkbox.name]: Checkbox,
        LSwitch,
        Checkbox2,
        [Popover.name]: Popover,
        [Dialog.name]: Dialog,
        'medal-decider': MedalDecider,
        'membership-item': MembershipPurchaseCard
    },
    data() {
        return {
            isProcessing: false,
            loadedUserId: 0,
            errorMessage: null,
            isAgreeWithRegistrationWaiver: false,
            isAgreeWithCodeEthics: false,
            isAgreeWithClubTerms: false,
            isLoadedClubTerms: false,
            isExistClubTerms: false,
            isShowBasket: false,
            likeCount: 0,
            OTEselected: null,
            currentYear: new Date().getFullYear(),
            nextYear: new Date().getFullYear() + 1,

            notCompletedProfileRequiredFields: '',

            selectedMembershipType: null,
            selectedClubId: null,
            selectedClubJoinTypeId: null,
            selectedCounty: null,

            isCurrentMainClub: true,
            IsShowClubSection: false,

            isActivePhysicalMembershipCard: true,

            selectedMembership: {
                id: 0,
                label: '',
                priceBeforeDiscount: 0,
                priceAfterDiscount: 0
            },
            selectedClub: {
                id: 0,
                name: '',
                county: '',
                site: null,
                clubJoinTypes: [{
                    id: 0,
                    name: '',
                    price: 0,
                    label: ''
                }]
            },
            selectedClubJoinType: {
                id: 0,
                name: '',
                price: 0
            },

            parentClub: null,
            parentClubJoinSwitch: false,
            parentClubJoinsAvailable: 0,

            renewalManagement: null,
            isRenewalActionInProgress: false,
            renewalConfirm: null,

            juniorNewEmail: null,
            juniorNewPassword: null,
            juniorNewPasswordConfirmation: null,
            upgradeJuniorToAdultMode: false,

            allData: {
                nextChangeClubDateString: null,
                isChangeClubAvailable: false,
                isAlreadyAddedToBasket: false,
                isNIlocation: false,
                userCounty: '',
                registerUserId: 0,
                sponsorOptions: [],
                selectedSponsorOptions: [],
                recurringMembershipPayments: [],
                currentMembership: {
                    id: 0,
                    label: '',
                    priceBeforeDiscount: 0,
                    priceAfterDiscount: 0,
                    isNextYearMembership: false,
                    membershipUpgrades: [{membershipType: 0, label: ''}],
                    isNextYearMembershipAvailable: false,
                    activePayYearValue: new Date().getFullYear(),
                    description: '',
                    isUpgrade: false,
                    isRenew: false,
                    headerLabel: '',
                    isClubJoinAllowed: false,
                },
                currentClubs: {
                    mainClubCurrentYear: {},// id: 0, name: '', joinTypeName: '', isMain: true },
                    clubsListCurrentYearWithoutMainClub: [],//{ id: 0, name: '', joinTypeName: '', isMain: false }],
                    mainClubNextYear: {},// id: 0, name: '', joinTypeName: '', isMain: true },
                    clubsListNextYearWithoutMainClub: [],//{ id: 0, name: '', joinTypeName: '', isMain: false }]
                },
                clubUpgrades: [{
                    id: 0,
                    name: '',
                    county: '',
                    clubJoinTypes: [{id: 0, name: '', price: 0}]
                }],
                counties: []
            }
        };
    },
    computed: {
        isAlreadyAddedToBasket() {
            return this.allData && this.allData.isAlreadyAddedToBasket;
        },
        isRenewalPanelVisible() {
            return !this.userId
                && !!(this.renewalManagement && this.renewalManagement.isVisible);
        },
        renewalTiRow() {
            return this.renewalManagement ? this.renewalManagement.tiRow : null;
        },
        renewalTiMembershipName() {
            const name = this.renewalTiRow ? this.renewalTiRow.membershipTypeName : null;

            // The enum label is "Swim Plus Membership"; the renewal surfaces show it as "Swim+".
            return name ? name.replace('Swim Plus', 'Swim+') : name;
        },
        renewalClubRows() {
            return this.renewalManagement && this.renewalManagement.clubRows
                ? this.renewalManagement.clubRows
                : [];
        },
        isRenewalActive() {
            return !!(this.renewalTiRow && this.renewalTiRow.state === 'Active');
        },
        isFullyOptedOut() {
            return this.isRenewalPanelVisible
                && !this.isRenewalActive
                && !this.renewalClubRows.some(club => club.state === 'Active');
        },
        renewalManagementYear() {
            return this.renewalManagement ? this.renewalManagement.renewalYear : this.renewalYear;
        },
        renewalYear() {
            return this.allData && this.allData.currentMembership
                ? this.allData.currentMembership.activePayYearValue
                : this.currentYear;
        },
        isMembershipWithDiscount() {
            return this.allData && this.allData.currentMembership && this.allData.currentClubs &&
                ((this.allData.currentMembership.isNextYearMembershipAvailableValue && this.allData.currentClubs.mainClubNextYear) ||
                    (!this.allData.currentMembership.isNextYearMembershipAvailableValue && this.allData.currentClubs.mainClubCurrentYear) ||
                    this.selectedClubJoinTypeId);
        },
        isRegistrationCompleted() {
            const preloadedUser = this.userId
                ? null
                : store.getters.getUserShortInfo;

            if (preloadedUser) {
                let value = preloadedUser.details.isRegistrationCompleted;
                this.notCompletedProfileRequiredFields = preloadedUser.details.notCompletedProfileRequiredFields;
                return value;
            }
            return true;
        },
        loginUrl() {
            return process.env.url.oldAppLogin;
        },
        isClubRegistration() {
            return this.selectedClubJoinTypeId && this.selectedClubJoinTypeId !== 0;
        },
        isSaveButtonVisible() {
            return (this.isClubRegistration || this.selectedMembershipType > 0) && (!this.isClubRegistration || this.isAgreeWithClubTerms) && this.isAgreeWithRegistrationWaiver && this.isAgreeWithCodeEthics;
        },
        saveButtonText() {
            if (this.total > 0) {
                return "Confirm and Pay";
            } else {
                return "Save";
            }
        },
        priceMembership() {
            var value = 0;

            if (this.selectedMembershipType) {
                if (this.isMembershipWithDiscount) {
                    value = this.selectedMembership.priceAfterDiscount;
                } else {
                    value = this.selectedMembership.priceBeforeDiscount;
                }
            }

            return value;
        },
        priceClub() {
            var value = 0;
            if (this.selectedClubJoinTypeId) {
                value = this.selectedClubJoinType.price;
            }
            return value;
        },
        total() {
            var value = this.priceMembership + this.priceClub;
            return value;
        },
        availableClubs() {
            var self = this;
            if (self.selectedCounty) {
                self.selectedClubId = null;
                return self.allData.clubUpgrades.filter(club => {
                    return club.county === self.selectedCounty || !club.county;
                });
            }
            return self.allData.clubUpgrades;
        },
        isMembershipUpgradeAvailable() {
            return this.isArrayHaveData(this.allData.currentMembership.membershipUpgrades) && !this.allData.isAlreadyAddedToBasket;
        },
        isActiveCurrentYear() {
            return this.allData.currentMembership.activePayYearValue === this.currentYear;
        },
        isAllAvailableClubsJoined() {
            if (this.isActiveCurrentYear) {
                if (this.allData.currentClubs.mainClubCurrentYear &&
                    this.allData.currentClubs.clubsListCurrentYearWithoutMainClub &&
                    this.allData.currentClubs.clubsListCurrentYearWithoutMainClub.length >= 1) {
                    return true;
                }
            } else {
                if (this.allData.currentClubs.mainClubNextYear &&
                    this.allData.currentClubs.clubsListNextYearWithoutMainClub &&
                    this.allData.currentClubs.clubsListNextYearWithoutMainClub.length >= 1) {
                    return true;
                }
            }
            return false;
        },
        isJoinTheClubAvailable() {
            if (this.isAllAvailableClubsJoined || !this.isArrayHaveData(this.allData.clubUpgrades)) {
                return false;
            }
            var isSelectedMembershipAllowsClub = this.selectedMembershipType && this.selectedMembership.priceBeforeDiscount > 0 && this.selectedMembership.isClubJoinAllowed;

            var isCurrentMembershipAllowsClubs = this.allData.currentMembership.isNextYearMembership === !this.isActiveCurrentYear
                && this.allData.currentMembership.priceBeforeDiscount > 0
                && this.allData.currentMembership.isClubJoinAllowed;

            var result = isCurrentMembershipAllowsClubs || isSelectedMembershipAllowsClub;

            return result;
        },
        isJoinTheClubOptionsAvailable() {
            return this.selectedClub && this.isArrayHaveData(this.selectedClub.clubJoinTypes) && this.selectedClubId && this.selectedClubId > 0;
        },
        isFreeLicenceUsed() {
            var isFreeLicenseSelected = this.selectedMembershipType && !this.selectedMembership.isTiMember;
            return (this.selectedMembershipType === null || isFreeLicenseSelected) &&
                !this.allData.currentMembership.isTiMember;
        },
        isActivePhysicalMembershipCardForPaid() {
            if (this.isFreeLicenceUsed) {
                this.isActivePhysicalMembershipCard = false;
                return false;
            } else {
                this.isActivePhysicalMembershipCard = true;
                return true;
            }
        },
        isClubStateChanged() {
            return false; //currently no need to uses  // MembershipFullInfoModel.IsChangeClubAvailable
            var isChangedCurrentYear = this.allData.currentClubs.mainClubCurrentYear && !this.allData.currentClubs.mainClubCurrentYear.isMain;
            var isChangedNextYear = this.allData.currentClubs.mainClubNextYear && !this.allData.currentClubs.mainClubNextYear.isMain;
            return isChangedCurrentYear || isChangedNextYear;
        },
        selectedCountyName() {
            if (this.selectedCounty) {
                return this.selectedCounty;
            }
            return 'All Counties';
        },
        selectStandardTypeEnumValue() {
            let standardTypeEnumValue = null;
            if (this.selectedClubId)
                standardTypeEnumValue = this.availableClubs.filter(s => s.id == this.selectedClubId)[0].standardTypeEnumValue;
            return standardTypeEnumValue;
        }
    },
    methods: {
        membershipLabel() {
            if (this.allData.currentMembership.isRenew && !this.allData.currentMembership.isUpgrade) {
                this.allData.currentMembership.headerLabel = 'Renew Membership';
            } else if (!this.allData.currentMembership.isRenew && this.allData.currentMembership.isUpgrade) {
                this.allData.currentMembership.headerLabel = 'Upgrade Membership';
            } else if (!this.allData.currentMembership.isRenew && !this.allData.currentMembership.isUpgrade) {
                return;
            }
        },
        saveClubFile() {
            if (!this.isLoadedClubTerms) {
                var self = this;
                var data = {
                    type: 1,
                    id: this.selectedClubId,
                    idString: null,
                    year: this.allData.currentMembership.activePayYearValue
                };

                svc.getFile(data).then(response => {
                    var allData = response.body;
                    if (allData && allData.bytes && allData.name) {
                        download('data:application/pdf;base64,' + allData.bytes, allData.name, "application/pdf");
                        self.isExistClubTerms = true;
                    } else {
                        self.isExistClubTerms = false;
                    }
                    self.isLoadedClubTerms = true;
                });
            }
        },
        getClubSafeguardFile() {
            var self = this;
            var data = {
                type: 3,
                id: this.selectedClubId,
                idString: null,
                year: this.allData.currentMembership.activePayYearValue
            };

            svc.getFile(data).then(response => {
                var allData = response.body;
                if (allData && allData.bytes && allData.name) {
                    download('data:application/pdf;base64,' + allData.bytes, allData.name, "application/pdf");
                } else {
                    self.$showError("Club admin hasn�t uploaded a file.");
                }
            });
        },
        saveClubChanges() {
            if (this.isClubStateChanged) {
                var self = this;
                var currentYearId = '';
                if (self.allData.currentClubs.mainClubCurrentYear && !self.allData.currentClubs.mainClubCurrentYear.isMain) {
                    var newCurrentYearClub = self.allData.currentClubs.clubsListCurrentYearWithoutMainClub.filter(x => x.isMain);
                    if (newCurrentYearClub && newCurrentYearClub.length === 1) {
                        currentYearId = newCurrentYearClub[0].id;
                    }
                }

                var nextYearId = '';
                if (self.allData.currentClubs.mainClubNextYear && !self.allData.currentClubs.mainClubNextYear.isMain) {
                    var newNextYearClub = self.allData.currentClubs.clubsListNextYearWithoutMainClub.filter(x => x.isMain);
                    if (newNextYearClub && newNextYearClub.length === 1) {
                        nextYearId = newNextYearClub[0].id;
                    }
                }

                self.isProcessing = true;
                svc.changeMainClub(currentYearId, nextYearId, self.getValueOrZero(self.userId)).then(response => {
                    var allData = response.body;
                    self.isProcessing = false;

                    if (!allData) {
                        self.$showError(null);
                    }
                    if (!allData.isSuccess) {
                        self.$showError(allData.message);
                        if (allData.currentUserId === 0) {
                            window.location.href = self.loginUrl();
                            return;
                        }
                    } else {
                        self.$showSuccess("Primary club settings confirmed");
                        if (!self.userId || store.getters.getCurrentUser.id === self.userId) {
                            EventBus.$emit("load-dashboard-data");
                        }
                        self.getData();
                    }
                    self.isProcessing = false;
                }, response => {
                    self.isProcessing = false;
                    self.$showError(null);
                });
            }
        },
        mainOrAdditional(value) {
            if (value) {
                return "Primary Club";
            }
            return "Secondary Club";
        },
        switchMainClubNextYear(id) {
            this.allData.currentClubs.mainClubNextYear.isMain = this.allData.currentClubs.mainClubNextYear.id === id;
            this.allData.currentClubs.clubsListNextYearWithoutMainClub.forEach(club => {
                club.isMain = club.id === id;
            });
        },
        switchMainClubCurrentYear(id) {
            this.allData.currentClubs.mainClubCurrentYear.isMain = this.allData.currentClubs.mainClubCurrentYear.id === id;
            this.allData.currentClubs.clubsListCurrentYearWithoutMainClub.forEach(club => {
                club.isMain = club.id === id;
            });
        },
        isArrayHaveData(object) {
            return object && object.length > 0 && (object[0].id > 0 || object.length > 1);
        },
        isShowOTEOption(option) {
            if (option.isDependencyOnAnyClub) {
                if (this.selectedClubJoinTypeId == null
                    && this.allData.currentClubs.idsClubsNextYear.length > 0
                    && this.allData.currentMembership.isTiMember
                    && this.allData.currentMembership.isCurrentYearMembershipPayment
                    && !this.allData.isSelectedOTE
                    && option.dependencyMembershipIds.includes(this.selectedMembershipType)) {
                    return true;
                }
                if (this.selectedClubJoinTypeId != null
                    && this.allData.currentMembership.isTiMember
                    && !this.allData.isSelectedOTE
                    && this.allData.currentMembership.isCurrentYearMembershipPayment
                    && option.dependencyMembershipIds.includes(this.selectedMembershipType)) {
                    return true;
                } else return false;
            } else {
                if (this.selectedClubJoinTypeId == null
                    && this.allData.currentClubs.idsClubsNextYear.length > 0
                    && this.allData.currentMembership.isTiMember
                    && this.allData.currentMembership.isCurrentYearMembershipPayment
                    && !this.allData.isSelectedOTE
                    && option.dependencyMembershipIds.includes(this.selectedMembershipType)) {
                    return false;
                }
                if (this.selectedClubJoinTypeId == null
                    && this.allData.currentMembership.isTiMember
                    && this.allData.currentMembership.isCurrentYearMembershipPayment
                    && !this.allData.isSelectedOTE
                    && option.dependencyMembershipIds.includes(this.selectedMembershipType)) {
                    return true;
                } else return false;
            }
        },
        changeSelectedFilterClubs() {
            var self = this;
            self.clearOTEOptions();
            self.isAgreeWithRegistrationWaiver = false;
            self.isAgreeWithCodeEthics = false;
            self.isAgreeWithClubTerms = false;
            self.selectedClubId = null;
            self.selectedClubJoinTypeId = null;
            self.isLoadedClubTerms = false;
        },
        clearPurchaseCard() {
            this.allData.currentMembership.allMemebershipUpgrades.forEach(x => x.isSelected = false);
        },
        scrollToItem(itemName) {
            setTimeout(() => {
                let item = document.getElementById(itemName);
                if (item && item.getBoundingClientRect && item.getBoundingClientRect()) {
                    window.scrollTo({top: item.getBoundingClientRect().y - 100, behavior: 'smooth'});
                }
            }, 10);
        },
        expandItem(item) {
            this.isShowBasket = false;
            if (item.isPurchaseHide && item.isSelected) {
                this.selectedMembershipType = null;
                this.clearPurchaseCard();
                this.changeSelectedMembership();
                return;
            }
            if (item.id == this.selectedMembershipType || item.isSelected) {
                this.selectedMembershipType = null;
                this.clearPurchaseCard();
                this.changeSelectedMembership();
            } else {
                this.clearPurchaseCard();
                this.selectedMembershipType = item.id;
                this.changeSelectedMembership();
                this.allData.currentMembership.allMemebershipUpgrades.forEach(x => {
                    if (x.id == item.id) {
                        x.isSelected = true;
                    }
                });
            }
            setTimeout(() => {
            }, 10);
        },
        becomeMember() {
            this.isShowBasket = true;
            this.scrollToItem('clubsection1');
        },
        goToPurchase() {
            this.isShowBasket = true;
            location.href = "#clubsection1";
            //this.scrollToItem('basketdetails1');
        },
        goBackToPurchases() {
            this.selectedMembershipType = null;
            this.clearPurchaseCard();
            this.changeSelectedMembership();
            this.isShowBasket = false;
            location.href = "#membershipupgradelist";
            //this.scrollToItem('membershipupgradelist');
        },
        changeSelectedMembership() {
            var self = this;
            self.clearOTEOptions();
            self.isAgreeWithRegistrationWaiver = false;
            self.isAgreeWithCodeEthics = false;
            self.isAgreeWithClubTerms = false;
            //self.IsShowClubSection = false;

            if (!self.selectedMembershipType) {
                self.selectedClubId = null;
                self.selectedClubJoinTypeId = null;
                self.isLoadedClubTerms = false;
                self.isAgreeWithClubTerms = false;
                self.IsShowClubSection = false;
                return;
            }
            var array = self.allData.currentMembership.membershipUpgrades.filter(membership => {
                return membership.id === self.selectedMembershipType;
            });

            if (array && array.length === 1) {
                self.selectedMembership = array[0];
                if (self.selectedMembership.priceBeforeDiscount <= 0) {
                    self.selectedClubId = null;
                    self.selectedClubJoinTypeId = null;
                    self.isLoadedClubTerms = false;
                    self.isAgreeWithClubTerms = false;
                    self.IsShowClubSection = false;
                } else if (this.isParentClubJoinTypeAvailable() && !this.selectedClubId && !this.selectedClubJoinTypeId) {
                    this.parentClubJoinSwitch = true;
                    this.joinToParentClub();
                }
            } else {
                //self.$showError("Can't retrieve the membership");
            }
            this.$console("Selected membership is " + self.selectedMembership.label);
        },
        clearOTEOptions() {
            this.allData.supportOTEDependencyOptions
                .forEach(item => item.inerCheckBoxes
                    .forEach(x => x.isSelected = false));
        },
        changeOTE(item) {
            let self = this;
            if (this.allData.supportOTEDependencyOptions.some(x => self.isShowOTEOption(x))) {
                self.OTEselected = self.allData.supportOTEDependencyOptions.filter(item => self.isShowOTEOption(item))[0];
                if (self.OTEselected.inerCheckBoxes.length > 1 && self.OTEselected.inerCheckBoxes.filter(x => x.isSelected).length > 1) {
                    let i = self.OTEselected.inerCheckBoxes.filter(x => x.fieldCode != item.fieldCode);
                    self.OTEselected.inerCheckBoxes.filter(x => x.fieldCode != item.fieldCode)[0].isSelected = false;
                    return;
                }
            }
        },
        changeSelectedClub() {
            var self = this;
            self.clearOTEOptions();
            var array = self.allData.clubUpgrades.filter(club => {
                return club.id === self.selectedClubId;
            });

            if (array && array.length === 1) {
                self.selectedClub = array[0];
                self.selectedClubJoinTypeId = null;
                self.isLoadedClubTerms = false;
                self.isAgreeWithClubTerms = false;
            } else {
                self.$showError("Can't retrieve the club");
            }

            this.$console("Selected club is " + self.selectedClub.name);
        },
        changeSelectedClubJoinType() {
            var self = this;
            self.clearOTEOptions();
            if (!self.selectedClub.clubJoinTypes) {
                this.$console("None");
            }
            var array = self.selectedClub.clubJoinTypes.filter(clubType => {
                this.isShowBasket = true;
                return clubType.id === self.selectedClubJoinTypeId;
            });
            if (array && array.length === 1) {
                self.selectedClubJoinType = array[0];
            } else {
                self.$showError("Can't retrieve the club join option");
            }

            this.$console("Selected club join type is " + self.selectedClubJoinType.name);
        },
        getDescription(data) {
            if (data) {
                return data.htmlDescription;
            }
            return '';
        },
        getMembershipName(data) {
            if (data) {
                if (this.isMembershipWithDiscount) {
                    if (data.namePriceAfterDiscount) {
                        return data.namePriceAfterDiscount;
                    }
                } else {
                    if (data.namePriceBeforeDiscount) {
                        return data.namePriceBeforeDiscount;
                    }
                }
            }
        },
        getName(data) {
            if (data) {
                if (data.name) {
                    return data.name;
                }
            }
            return '';
        },
        getClubJoinTypeName(club) {
            if (club) {
                if (club.joinTypeName) {
                    return " - " + club.joinTypeName;
                }
            }
            return '';
        },
        getPrice(data) {
            if (data) {
                if (data.price) {
                    return data.price;
                }
            }
            return 0;
        },
        getValueOrZero(value) {
            if (value) {
                return value;
            }
            return 0;
        },
        getData() {
            var self = this;
            self.isProcessing = true;

            self.upgradeJuniorToAdultMode = false;

            if (self.userId === -1) {
                return;
            }

            if (self.userId && self.loadedUserId <= 0) {
                self.loadedUserId = self.userId;
            }

            //if (window.location.hash.replace("#", "")) {
            //    self.loadedUserId = window.location.hash.replace("#", "");
            //}

            EventBus.$emit("user-load-dashboard-card", self.loadedUserId);

            if (self.userId) {
                self.renewalManagement = null;
            } else {
                self.loadRenewalManagement();
            }

            self.isProcessing = true;
            svc.getMembershipUpgradeInfo(self.loadedUserId)
                .then(response => {
                    var allData = response.body;
                    self.isProcessing = false;

                    if (!allData) {
                        self.$showError("Something went wrong!");
                        return;
                    }
                    if (!allData.isSuccess) {
                        if (!allData.currentMembership) {
                            self.errorMessage = allData.message;
                        } else {
                            self.$showError(allData.message);
                        }
                        return;
                    } else {
                        self.allData = allData;
                        if (allData.currentMembership.membershipUpgrades && allData.currentMembership.membershipUpgrades[0] && allData.currentMembership.membershipUpgrades[0].id === 0) {
                            allData.currentMembership.membershipUpgrades[0].id = null;
                        }
                        self.currentYear = self.allData.currentMembership.currentYear;
                        self.nextYear = self.currentYear + 1;
                    }
                    self.selectedClubId = null;
                    self.selectedClubJoinTypeId = null;
                    self.selectedMembershipType = null;
                    self.selectedCounty = null;

                    if (self.userId && self.isParentClubJoinTypeAvailable() && self.allData.currentMembership.isTiMember) {
                        self.parentClubJoinSwitch = true;
                        self.joinToParentClub();
                    }

                    self.$console();
                    self.$console("Membership info loaded: ");
                    self.$console({UpgradeInfo: self.allData});
                    self.$console("User age is " + self.allData.currentMembership.age);
                    self.membershipLabel();
                }, response => {
                    self.isProcessing = false;
                    self.errorMessage = "Something went wrong. We can not load this page at the moment.";
                });
        },
        changePhysicalCardStatus() {
            var self = this;
            svc.getChangePhysicalCardStatus(self.getValueOrZero(self.userId), self.allData.physicalMembershipCard.isActive)
                .then(response => {
                    self.isProcessing = false;
                    if (!response.body) {
                        self.$showSuccess();
                    } else {
                        self.$showError();
                    }
                }, () => {
                    self.isProcessing = false;
                    self.errorMessage = "Something went wrong. We can not load this page at the moment.";
                })
        },
        saveData(isAddToCard) {
            var self = this;

            if (!self.isSaveAllowed()) {
                self.$showError("Saving is not allowed!");
                return;
            }

            if (this.allData.supportOTEDependencyOptions.some(x => self.isShowOTEOption(x))) {
                self.OTEselected = self.allData.supportOTEDependencyOptions.filter(item => self.isShowOTEOption(item))[0];
                if (self.OTEselected.inerCheckBoxes.length > 1 && self.OTEselected.inerCheckBoxes.filter(x => x.isSelected).length > 1) {
                    self.$showError("Please select one option!");
                    return;
                }
            }

            if (!self.selectedClubJoinTypeId) {
                self.selectedClubId = null
            }
            const selectedSponsors = self.allData.selectedSponsorOptions.join("||");
            self.isProcessing = true;
            var data = {
                userId: self.getValueOrZero(self.userId),
                membershipId: self.getValueOrZero(self.selectedMembershipType),
                clubId: self.getValueOrZero(self.selectedClubId),
                clubJoinTypeId: self.getValueOrZero(self.selectedClubJoinTypeId),
                isJoinJuniorToParentClub: self.parentClubJoinSwitch,
                isPhysicalCard: self.isActivePhysicalMembershipCard,
                isAgreeWithBMWAgreement: self.allData.isAcceptedSponsorAgreement,
                isNIlocation: self.allData.isNIlocation,
                isAddToCard: isAddToCard,
                selectedSponsorOptions: selectedSponsors,
                selectedOTEOptions: self.allData.supportOTEDependencyOptions.some(x => self.isShowOTEOption(x))
                    ? self.OTEselected.inerCheckBoxes.filter(x => x.isSelected).map(m => m.fieldCode).join("||") : ''
            };

            svc.prepareMembershipRegistration(data).then(response => {
                var allData = response.body;
                if (!allData) {
                    self.$showError("Something went wrong!");
                }
                if (!allData.isSuccess) {
                    self.$showError(allData.message);
                } else {
                    if (self.selectedMembershipType && self.priceMembership === 0 && !allData.redirectUrl) {
                        self.$showSuccess("TI Membership successfully changed to " + self.getMembershipName(self.selectedMembership));
                    }

                    if (self.selectedClubId && self.priceClub === 0 && !allData.redirectUrl && !isAddToCard) {
                        self.$showSuccess(self.getName(self.selectedClub) + " - membership confirmed.");
                    }

                    if (allData.redirectUrl) {
                        self.$showSuccess("Data successfully saved. You will be redirected to billing page.");
                        self.$router.push({path: allData.redirectUrl});
                    } else {
                        EventBus.$emit("load-dashboard-data");
                        self.getData();
                    }
                    if (isAddToCard) {
                        EventBus.$emit('update-basket');
                    }
                }
                self.isProcessing = false;
            }, response => {
                self.isProcessing = false;
                self.$showError(null);
            });
        },
        isSaveAllowed() {
            var isAllowedMembership = this.selectedMembershipType && this.selectedMembershipType > 0;
            var isAllowedClub = this.selectedClubJoinTypeId && this.selectedClubJoinTypeId !== 0;
            return (isAllowedMembership || isAllowedClub) && this.isShowBasket;
        },
        joinToParentClub() {
            if (this.parentClubJoinSwitch) {
                this.selectedClubId = this.parentClub.id;
                this.selectedClub = this.parentClub;
                this.selectedClubJoinTypeId = this.parentClub.joinTypeId;
                this.selectedClubJoinType = {
                    id: this.selectedClubJoinTypeId,
                    name: this.parentClub.joinTypeName,
                    price: 0
                };
                this.selectedClub.clubJoinTypes = [this.selectedClubJoinType];
            } else {
                this.selectedClubId = null;
                this.selectedClub = null;
                this.selectedClubJoinTypeId = null;
                this.selectedClubJoinType = null;
            }
        },
        isParentClubJoinTypeAvailable() {
            var self = this;
            self.$console();
            var preloadedUser = store.getters.getUserShortInfo;
            if (preloadedUser && preloadedUser.isSuccess) {

                if (self.isActiveCurrentYear) {

                    var isAdditionalClubCurrentYear = self.allData.currentClubs.clubsListCurrentYearWithoutMainClub && self.allData.currentClubs.clubsListCurrentYearWithoutMainClub.length > 0;

                    if (preloadedUser.clubs.mainClubCurrentYear && !isAdditionalClubCurrentYear) {

                        var isAdditionalClubAsParentCurrentYear = isAdditionalClubCurrentYear && self.allData.currentClubs.clubsListCurrentYearWithoutMainClub[0].id === preloadedUser.clubs.mainClubCurrentYear.id;
                        var isMainClubConnectedCurrentYear = self.allData.currentClubs.mainClubCurrentYear && self.allData.currentClubs.mainClubCurrentYear.id === preloadedUser.clubs.mainClubCurrentYear.id;
                        var isClubAreadyConnectedCurrentYear = isMainClubConnectedCurrentYear || isAdditionalClubAsParentCurrentYear;

                        if (!isClubAreadyConnectedCurrentYear) {
                            this.parentClub = preloadedUser.clubs.mainClubCurrentYear;
                            self.$console("Loaded current year parent main club:");
                            self.$console({ParentClub: this.parentClub});
                            self.$console("Juniors Joins Available:" + this.parentClub.juniorsAvailable);
                            this.parentClubJoinsAvailable = this.parentClub.juniorsAvailable;
                            return this.parentClub.juniorsAvailable > 0;
                        }
                    } else {
                        self.$console("No current year parent club info loaded.");
                    }
                } else {
                    var isAdditionalClubNextYear = self.allData.currentClubs.clubsListNextYearWithoutMainClub && self.allData.currentClubs.clubsListNextYearWithoutMainClub.length > 0;

                    if (preloadedUser.clubs.mainClubNextYear && !isAdditionalClubNextYear && !isClubAreadyConnectedNextYear) {

                        var isAdditionalClubAsParentNextYear = isAdditionalClubNextYear && self.allData.currentClubs.clubsListNextYearWithoutMainClub[0].id === preloadedUser.clubs.mainClubNextYear.id;
                        var isMainClubConnectedNextYear = self.allData.currentClubs.mainClubNextYear && self.allData.currentClubs.mainClubNextYear.id === preloadedUser.clubs.mainClubNextYear.id;
                        var isClubAreadyConnectedNextYear = isMainClubConnectedNextYear || isAdditionalClubAsParentNextYear;

                        if (!isClubAreadyConnectedNextYear) {
                            this.parentClub = preloadedUser.clubs.mainClubNextYear;
                            self.$console("Loaded next year parent main club:");
                            self.$console({ParentClub: this.parentClub});
                            self.$console("Juniors Joins Available:" + this.parentClub.juniorsAvailable);
                            this.parentClubJoinsAvailable = this.parentClub.juniorsAvailable;
                            return this.parentClub.juniorsAvailable > 0;
                        }
                    } else {
                        self.$console("No next year parent club info loaded.");
                    }
                }
            }
            self.parentClubJoinSwitch = false;
            self.$console("No parent clubs available");

            return false;
        },
        closePopoverClick() {
            event.preventDefault();
            document.getElementById('popover-explanations').click();
        },
        upgradeJuniorToAdultSwitch() {
            this.upgradeJuniorToAdultMode = !this.upgradeJuniorToAdultMode;
        },
        upgradeJuniorToAdultConfirmed() {
            var self = this;

            if (!self.juniorNewEmail || !self.juniorNewPassword || !self.juniorNewPasswordConfirmation) {
                self.$showError("Please fill required field!");
                return;
            }
            if (self.juniorNewPassword != self.juniorNewPasswordConfirmation) {
                self.$showError("Password and password confirmation are not matched!");
                return;
            }

            if (!self.validateEmail(self.juniorNewEmail)) {
                self.$showError("Email address is not valid!");
                return;
            }

            self.isProcessing = true;
            var data = {
                juniorId: self.userId,
                email: self.juniorNewEmail,
                password: self.juniorNewPassword
            };

            svc.upgradeJuniorToAdult(data).then(response => {
                var allData = response.body;
                if (!allData) {
                    self.$showError("Something went wrong!");
                }
                if (!allData.isSuccess) {
                    self.$showError(allData.message);
                    self.isProcessing = false;
                } else {
                    self.$showSuccess(self.allData.userName + " has created own adult account and will be removed from your juniors section. Page will be refreshed in 2 seconds.");
                    setTimeout(function () {
                        self.isProcessing = false;
                        self.$router.go();
                    }, 3000);
                }
            }, response => {
                self.isProcessing = false;
                self.$showError(null);
            });
        },
        validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },

        clubBadgeLetter(club) {
            const match = /[a-z0-9]/i.exec(club.clubName || '');
            return match ? match[0].toUpperCase() : 'C';
        },

        renewalUnavailableText(reason) {
            switch (reason) {
                case 'TiAutoRenewalRequired':
                    return 'Requires active TI membership';
                case 'ClubOptInNotAllowed':
                    return 'Not offered by this club';
                case 'ClubNoLongerAvailable':
                    return 'Club no longer available';
                case 'NoUsablePaymentAnchor':
                    return 'Saved payment details unavailable';
                case 'NoSourcePayment':
                    return 'No previous payment to renew';
                case 'PaymentCancelled':
                    return 'Previous payment was cancelled';
                case 'NoTiMembership':
                    return 'No active TI membership';
                default:
                    return '';
            }
        },

        loadRenewalManagement() {
            const self = this;
            return svc.getRenewalManagement().then(response => {
                self.renewalManagement = response.body || null;
            }).catch(() => {
                self.renewalManagement = null;
            });
        },

        handleRenewalActionResult(response, successMessage) {
            const result = response.body;

            if (!result) {
                this.$showError("Something went wrong!");
                return false;
            }
            if (!result.isSuccess) {
                this.$showError(result.message);
                return false;
            }

            this.$showSuccess(successMessage);
            return true;
        },

        runRenewalAction(request, successMessage) {
            if (this.isRenewalActionInProgress) {
                return;
            }

            const self = this;
            self.isRenewalActionInProgress = true;

            request.then(response => {
                self.handleRenewalActionResult(response, successMessage);
            }).catch(error => {
                self.$showError(error);
            }).finally(() => {
                self.loadRenewalManagement().then(() => {
                    self.isRenewalActionInProgress = false;
                });
            });
        },

        optInTiAutoRenewal() {
            this.runRenewalAction(
                svc.submitRenewalOptIn({optInTi: true, clubIds: []}),
                'Auto-renewal is now active for your TI membership.');
        },

        optInClubAutoRenewal(club) {
            this.runRenewalAction(
                svc.submitRenewalOptIn({optInTi: false, clubIds: [club.clubId]}),
                `Auto-renewal is now active for ${club.clubName}.`);
        },

        confirmTiOptOut() {
            if (this.isRenewalActionInProgress) {
                return;
            }

            const hasActiveClub = this.renewalClubRows.some(club => club.state === 'Active');

            this.renewalConfirm = {
                paragraphs: [
                    hasActiveClub
                        ? "You're turning off auto-renewal for your TI membership. Because a Club membership can't renew without TI, Club auto-renewal will be turned off too."
                        : "You're turning off auto-renewal for your TI membership.",
                    hasActiveClub
                        ? 'Both memberships stay active for the current term, neither will renew next year. Continue?'
                        : 'Your membership stays active for the current term, it just will not renew next year. Continue?'
                ],
                onConfirm: () => this.optOutTiAutoRenewal()
            };
        },

        cancelRenewalConfirm() {
            this.renewalConfirm = null;
        },

        acceptRenewalConfirm() {
            const confirmed = this.renewalConfirm;
            this.renewalConfirm = null;

            if (confirmed) {
                confirmed.onConfirm();
            }
        },

        optOutTiAutoRenewal() {
            const paymentId = this.renewalTiRow ? this.renewalTiRow.recurringPaymentId : null;
            if (!paymentId) {
                return;
            }

            this.runRenewalAction(
                svc.disableTiAutoRenewal(paymentId),
                'Auto-renewal has been turned off for your TI membership.');
        },

        confirmClubOptOut(club) {
            if (this.isRenewalActionInProgress) {
                return;
            }

            this.renewalConfirm = {
                paragraphs: [
                    `You're turning off auto-renewal for ${club.clubName}. Your TI membership is unaffected.`,
                    'Your club membership stays active for the current term, it just will not renew next year. Continue?'
                ],
                onConfirm: () => this.optOutClubAutoRenewal(club)
            };
        },

        optOutClubAutoRenewal(club) {
            if (!club.userClubMembershipId) {
                return;
            }

            this.runRenewalAction(
                svc.disableClubAutoRenewal(club.userClubMembershipId),
                `Auto-renewal has been turned off for ${club.clubName}.`);
        }
    },
    mounted() {
        var self = this;
        self.getData();

        EventBus.$off('user-load-upgrade-membership');
        EventBus.$on("user-load-upgrade-membership", (id) => {
            self.loadedUserId = id;
            self.getData();
        });
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/membership/upgrade-membership/upgrade-membership.js